import moment from "moment";
import { api } from "common";
import { Column } from "material-table";
import { IPanicType } from "common/src/types";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { CustomMaterialTable } from "components/CustomMaterialTable";

const Panics = () => {
  const { completePanic } = api;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const panicdata = useSelector((state) => state.panicdata);

  const columns: Column<IPanicType>[] = [
    {
      title: "Id",
      field: "id",
    },
    {
      field: "bookingId",
      title: t("booking_id"),
    },
    {
      title: t("name"),
      field: "userName",
    },
    {
      title: t("email"),
      field: "userEmail",
    },
    {
      title: t("phone"),
      field: "userPhone",
    },
    {
      field: "isDriver",
      title: t("is_driver"),
      render: (rowData) => (rowData.isDriver ? t("yes") : t("no")),
    },
    {
      field: "date",
      title: t("created_date"),
      render: (rowData) => rowData.date ? moment(rowData.date).format('DD/MM/YYYY HH:mm') : null,
    },
    {
      field: "processDate",
      title: t("processed_date"),
      render: (rowData) => rowData.processDate ? moment(rowData.processDate).format('DD/MM/YYYY HH:mm') : null,
    },
  ];

  return (
    <CustomMaterialTable
      columns={columns}
      title={"emergency_calls"}
      data={panicdata.panics ?? []}
      isLoading={panicdata.loading}
      options={{
        rowStyle: (rowData) => {
          if (!rowData.processed) {
            return {
              filter: "drop-shadow(0 0 10px red)",
            };
          }
          return {};
        },
      }}
      actions={[
        (rowData) => ({
          icon: "check",
          tooltip: t("COMPLETE_CALL"),
          disabled: rowData.processed,
          onClick: (_, rowData) => {
            dispatch(completePanic(rowData as any));
          },
        }),
      ]}
    />
  );
};

export default Panics;